import accountingAccountingEN from './messages/accounting/accounting.json';
import accountingChargeEN from './messages/accounting/charge.json';
import accountingReportingEN from './messages/accounting/reporting.json';
import accountingStatementEN from './messages/accounting/statement.json';
import agencyRatesEN from './messages/agencyRates.json';
import communicationsEN from './messages/communications.json';
import contactEN from './messages/contact.json';
import enumsEN from './messages/enums.json';
import foldersEN from './messages/folders.json';
import leaseAddLeaseEN from './messages/lease/addLease.json';
import leaseDetailEN from './messages/lease/detail.json';
import leaseLeaseEN from './messages/lease/lease.json';
import remainingMessagesEN from './messages/messages.json';
import myCompanyEN from './messages/myCompany.json';
import paymentsEN from './messages/payments.json';
import rentalUnitEN from './messages/rentalUnit.json';
import settingsEN from './messages/settings.json';
import templatesEN from './messages/templates.json';
import transactionsEN from './messages/transactions.json';

export const BackendMessagesEN = {
  accounting: {
    statement: accountingStatementEN,
    reporting: accountingReportingEN,
    charge: accountingChargeEN,
    ...accountingAccountingEN,
  },
  agencyRates: agencyRatesEN,
  communications: communicationsEN,
  contact: contactEN,
  enums: enumsEN,
  folders: foldersEN,
  lease: {
    ...leaseLeaseEN,
    detail: leaseDetailEN,
    addLease: leaseAddLeaseEN,
  },
  myCompany: myCompanyEN,
  rentalUnit: rentalUnitEN,
  settings: settingsEN,
  templates: templatesEN,
  payments: paymentsEN,
  transactions: transactionsEN,
  ...remainingMessagesEN,
};
